export default defineNuxtRouteMiddleware(to => {
  // /policy 또는 /{locale}/policy 로 접근 시 /policy/terms로 리다이렉트
  if (to.path.match(/^\/([a-z]{2}\/)?policy$/)) {
    const locale = to.path.match(/^\/([a-z]{2})\//) ? `/${to.path.match(/^\/([a-z]{2})\//)[1]}` : ''
    return navigateTo(`${locale}/policy/terms`)
  }

  // /introduction 또는 /{locale}/introduction 로 접근 시 /introduction/guardiann 리다이렉트
  if (to.path.match(/^\/([a-z]{2}\/)?introduction$/)) {
    const locale = to.path.match(/^\/([a-z]{2})\//) ? `/${to.path.match(/^\/([a-z]{2})\//)[1]}` : ''
    return navigateTo(`${locale}/introduction/guardiann`)
  }
})
